import { type INativeNotificationSettings } from '@/types/INativeNotificationSettings';
import { isRecord } from '@/utils/isRecord';

export const NATIVE_NOTIFICATION_SETTINGS_KEY = 'nativeNotificationSettings';

const DEFAULT_SETTINGS: INativeNotificationSettings = {
  enabled: true
};

const isNativeNotificationSettings = (
  value: unknown
): value is INativeNotificationSettings =>
  isRecord(value) && typeof value.enabled === 'boolean';

/**
 * Читает настройку нативных уведомлений из localStorage. При отсутствии или
 * повреждении записи возвращает дефолт (включено). Это UI-предпочтение
 * пользователя — при логауте не очищается (как настройки звука).
 *
 * @returns актуальная настройка нативных уведомлений
 */
export const readNativeNotificationSettings =
  (): INativeNotificationSettings => {
    const raw = localStorage.getItem(NATIVE_NOTIFICATION_SETTINGS_KEY);

    if (raw === null) {
      return DEFAULT_SETTINGS;
    }

    let parsed: unknown;

    try {
      parsed = JSON.parse(raw);
    } catch {
      return DEFAULT_SETTINGS;
    }

    if (!isNativeNotificationSettings(parsed)) {
      return DEFAULT_SETTINGS;
    }

    return parsed;
  };

/**
 * Сохраняет настройку нативных уведомлений в localStorage.
 *
 * @param settings - настройка для персиста
 */
export const saveNativeNotificationSettings = (
  settings: INativeNotificationSettings
): void => {
  localStorage.setItem(
    NATIVE_NOTIFICATION_SETTINGS_KEY,
    JSON.stringify(settings)
  );
};
